export const LOGIN = 'LOGIN'

import Constants from '../components/Constants.js';
import fetch from 'isomorphic-fetch'; 
import log from 'loglevel';
import { browserHistory } from 'react-router'
import Cookies from 'cookies-js';

export function login(email, password) {

  log.debug("Perfoming login action.");

  const body = new FormData();
  body.append('username', email);
  body.append('password', password);

  var headers = new Headers();
	headers.append("Content-Type", "application/x-www-form-urlencoded");

	fetch(`${Constants.API_HOST}api-token-auth/`, {
		method: "POST",
		// headers: headers,
		body: body
	})
  .then(function(response) {

    if (response.status >= 400) {
        throw new Error("Bad response from server");
    }
    else {
	    response.json().then(function(data) {

	    	if( Constants.COOKIE_DOMAIN ) {
			    Cookies.set('jwtsession', data['jwtsession'], { domain: Constants.COOKIE_DOMAIN });
	    	}
	    	else {
			    Cookies.set('jwtsession', data['jwtsession']);
	    	}
				browserHistory.push('/dashboard');
	    });
    }
  })

  return {
    type: LOGIN,
    email: email,
    password: password
  }
}



// WEBPACK FOOTER //
// ./src/actions/Auth.js